import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, NavigationExtras, Router, RouterStateSnapshot} from '@angular/router';
import {map, Observable, of} from 'rxjs';
import {AuthStore} from '../../+store/auth.store';
import {ReAuthenticateService} from '../../interceptors/token/re-authenticate-dialog/re-authenticate-user';
import {RETURN_URL_PARAM} from '../../types/navigation-management.types';

type IAuthGuardOptions = {
	fallbackRoute?: string;
	saveReturnUrl?: boolean;
	reAuthenticate?: boolean;
};

export function authGuard(options?: IAuthGuardOptions) {
	const fallbackRoute: string = options?.fallbackRoute ?? 'login';
	const saveReturnUrl: boolean = options?.saveReturnUrl ?? false;
	const reAuthenticate: boolean = options?.reAuthenticate ?? false;

	return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
		const authStore = inject(AuthStore);
		const router = inject(Router);
		const reAuthService = inject(ReAuthenticateService);

		const isAuthenticated: boolean = authStore.isAuthenticated();

		if (isAuthenticated) {
			return of(true);
		}

		const urlExtras: NavigationExtras = {};
		if (saveReturnUrl) {
			urlExtras.queryParams = {[RETURN_URL_PARAM]: state.url};
		}
		if (reAuthenticate && reAuthService.canReAuth$()) {
			return reAuthService.openReAuthenticateDialog().pipe(
				map(authResponse => {
					if (authResponse?.user) {
						console.log('[authGuard()] Re-authentication successful');
						return true;
					} else {
						console.log('[authGuard()] Re-authentication failed or cancelled');
						router.navigate([fallbackRoute], urlExtras).then(() => {});
						return false;
					}
				}),
			);
		} else {
			router.navigate([fallbackRoute], urlExtras).then(() => {});
		}
		return of(false);
	};
}
